import React, { useMemo } from "react";
import {
  IBackgroundConfigSchema,
  IBackgroundTypeConfigSchema,
  IResponsiveObjectSchema,
} from "../../../config/interfaces";
import { useResponsiveObject } from "../../../helpers/hooks/useResponsiveObject";
import "./MyBackground.css";

interface MyVideoBackgroundProps {
  backgroundConfig: IResponsiveObjectSchema<IBackgroundConfigSchema>;
}

export const MyVideoBackground: React.FC<MyVideoBackgroundProps> = ({
  backgroundConfig,
}) => {
  const bg = useResponsiveObject(backgroundConfig);
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const [isContentLoaded, setIsContentLoaded] = React.useState(false);

  React.useEffect(() => {
    // Ricarica il video quando cambia
    if (
      videoRef.current &&
      background_type === IBackgroundTypeConfigSchema.VIDEO
    ) {
      videoRef.current.load();
    }
  }, [bg?.background_src]);

  const contentStyle = useMemo(() => {
    const background_overlay_blur_radius = bg?.background_overlay_blur_radius;
    return {
      backdropFilter: background_overlay_blur_radius
        ? `blur(${background_overlay_blur_radius})`
        : undefined,
      WebkitBackdropFilter: background_overlay_blur_radius
        ? `blur(${background_overlay_blur_radius})`
        : undefined,
    };
  }, [bg]);

  if (!bg) return null;

  const { background_type, background_src, background_overlay, static_color } =
    bg;

  const getVideoTypeFromURI = (uri: string) => {
    const ext = uri.split(".").pop();
    if (ext === "mp4") return "video/mp4";
    else if (ext === "webm") return "video/webm";
    else if (ext === "ogg") return "video/ogg";
    else return "";
  };

  const renderContent = () => {
    if (background_type === IBackgroundTypeConfigSchema.VIDEO) {
      return (
        <video
          autoPlay
          playsInline
          loop
          muted
          className="content"
          ref={videoRef}
          onPlay={() => setIsContentLoaded(true)}
          style={contentStyle}
        >
          <source
            src={background_src}
            style={contentStyle}
            type={
              background_src ? getVideoTypeFromURI(background_src) : undefined
            }
          ></source>
        </video>
      );
    } else if (background_type === IBackgroundTypeConfigSchema.IMAGE) {
      return (
        <img
          src={background_src}
          onLoad={() => setIsContentLoaded(true)}
          alt="background"
          className="content"
          style={contentStyle}
        />
      );
    } else {
      return (
        <div className="content" style={{ background: static_color }}></div>
      );
    }
  };

  return (
    <div className="MyBackground">
      {renderContent()}

      {background_overlay && isContentLoaded ? (
        <div
          className="Overlay"
          style={{
            background: background_overlay,
          }}
        />
      ) : null}

      <div className={"Loading_Overlay " + (isContentLoaded ? "hide" : "")} />
    </div>
  );
};
